const roots = document.querySelectorAll('[data-bloomio-landing]');

for (const root of roots) {
  if (root.dataset.bloomioInitialized === 'true') continue;
  root.dataset.bloomioInitialized = 'true';

  for (const slider of root.querySelectorAll('[data-bloomio-quotes]')) {
    const cards = [...slider.querySelectorAll('[data-bloomio-quote]')];
    let index = cards.findIndex((card) => card.classList.contains('active'));
    if (index < 0) index = 0;
    const show = (next) => {
      index = (next + cards.length) % cards.length;
      cards.forEach((card, cardIndex) => card.classList.toggle('active', cardIndex === index));
    };
    slider.querySelector('[data-bloomio-prev]')?.addEventListener('click', () => show(index - 1));
    slider.querySelector('[data-bloomio-next]')?.addEventListener('click', () => show(index + 1));
  }

  const countdown = root.querySelector('[data-bloomio-countdown]');
  if (countdown) {
    let remaining = Number(countdown.dataset.seconds || 449522);
    const tick = () => {
      remaining = Math.max(0, remaining - 1);
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      const values = { days, hours, minutes, seconds };
      for (const [key, value] of Object.entries(values)) {
        const node = countdown.querySelector(`[data-${key}]`);
        if (node) node.textContent = `${String(value).padStart(2, '0')}${key === 'days' ? 'D' : key === 'hours' ? 'H' : key === 'minutes' ? 'M' : 'S'}`;
      }
    };
    window.setInterval(tick, 1000);
  }

  root.querySelector('[data-bloomio-show-reviews]')?.addEventListener('click', (event) => {
    root.querySelector('[data-bloomio-review-grid]')?.classList.add('is-expanded');
    event.currentTarget.hidden = true;
  });

  const cartTimerStorageKey = 'bloomio-cart-reservation-deadline';
  const initializeCartTimers = () => {
    for (const timer of root.querySelectorAll('[data-bloomio-cart-timer]:not([data-bloomio-timer-ready])')) {
      timer.dataset.bloomioTimerReady = 'true';
      const duration = Number(timer.dataset.seconds || 300) * 1000;
      let deadline = Number(sessionStorage.getItem(cartTimerStorageKey));
      if (!Number.isFinite(deadline) || deadline <= Date.now()) {
        deadline = Date.now() + duration;
        sessionStorage.setItem(cartTimerStorageKey, String(deadline));
      }

      const output = timer.querySelector('[data-bloomio-cart-countdown]');
      const renderTimer = () => {
        if (!timer.isConnected) return false;
        if (deadline <= Date.now()) {
          deadline = Date.now() + duration;
          sessionStorage.setItem(cartTimerStorageKey, String(deadline));
        }
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        const minutes = Math.floor(remaining / 60);
        const seconds = remaining % 60;
        if (output) output.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        return true;
      };

      renderTimer();
      const interval = window.setInterval(() => {
        if (!renderTimer()) window.clearInterval(interval);
      }, 1000);
    }
  };

  initializeCartTimers();
  new MutationObserver(initializeCartTimers).observe(root, { childList: true, subtree: true });
}
